import { API } from "aws-amplify";
import { useEffect, useState } from "react";

export const usePracticeOptions = () => {
  /** @type {import("types/commonTypes").Organization[]} */
  const initialState = [];
  const [practices, setPractices] = useState(initialState);

  practices.sort((a, b) => (a.name > b.name ? 1 : -1));

  const practicesOptions = practices.reduce(
    (acc, { id, name, speciality, phone }) => {
      const details = [name, speciality, phone]
        .filter((value) => !!value)
        .join(", ");
      return { ...acc, [id]: details };
    },
    {}
  );

  const getPracticeById = (recipientId) => {
    const practice = practices.find(({ id }) => recipientId === id);
    return practice?.name ?? "Referral Stream";
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await API.get("restApi", "/organizations", {});
        setPractices(result?.Items ?? []);
      } catch (error) {}
    };

    getData();
  }, []);

  return {
    practicesOptions,
    practices,
    getPracticeById,
  };
};
